import I18n from 'I18n';
import { memo, useMemo } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HR } from 'foundations-components/transitional/components/HR';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { ColorSquatch } from 'foundations-components/transitional/components/ColorSquatch';
import { ColorSwatch } from 'foundations-components/transitional/components/ColorSwatch';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import CampaignsPlatformLabelPopoverOwner from './CampaignsPlatformLabelPopoverOwner';
import CampaignsPlatformLabelPopoverBusinessUnit from './CampaignsPlatformLabelPopoverBusinessUnit';
import CampaignsPlatformLabelPopoverProperty from './CampaignsPlatformLabelPopoverProperty';
import { CampaignsIcon } from 'foundations-assets/icons/components/CampaignsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CampaignName({
  crmObject
}) {
  const {
    color,
    name
  } = useMemo(() => {
    return {
      color: getPropertyValue(crmObject, 'hs_color_hex', ''),
      name: getPropertyValue(crmObject, 'hs_name')
    };
  }, [crmObject]);
  return /*#__PURE__*/_jsxs(Flex, {
    columnGap: "100",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(Link, {
      href: `/marketing/${PortalIdParser.get()}/campaigns/${getPropertyValue(crmObject, 'hs_origin_asset_id')}`,
      children: name
    }), color && /*#__PURE__*/_jsx(ColorSwatch, {
      size: 6,
      color: color
    })]
  });
}
function CampaignsPlatformLabelPopover({
  campaignCrmObject
}) {
  const businessUnit = getPropertyValue(campaignCrmObject, 'hs_all_assigned_business_unit_ids');
  const owner = getPropertyValue(campaignCrmObject, 'hs_owner');
  const startDate = getPropertyValue(campaignCrmObject, 'hs_start_date');
  const endDate = getPropertyValue(campaignCrmObject, 'hs_end_date');
  const campaignColour = getPropertyValue(campaignCrmObject, 'hs_color_hex', '');
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "campaign-popover",
    position: "relative",
    children: [campaignColour && /*#__PURE__*/_jsx(ColorSquatch, {
      size: 6,
      position: "absolute",
      insetInlineStart: "-1px",
      insetBlockStart: "-1px",
      insetBlockEnd: "-1px",
      color: campaignColour,
      blockSize: "calc(100% + 2px)",
      borderStartEndRadius: "0",
      borderEndEndRadius: "0",
      cursor: "default"
    }), /*#__PURE__*/_jsx(DescriptionList, {
      padding: "500",
      children: /*#__PURE__*/_jsx(CampaignsPlatformLabelPopoverProperty, {
        label: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          children: [/*#__PURE__*/_jsx(CampaignsIcon, {}), /*#__PURE__*/_jsx(Text, {
            typography: "heading-25",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "campaignSelect.formControlLabel"
            })
          })]
        }),
        value: /*#__PURE__*/_jsx(CampaignName, {
          crmObject: campaignCrmObject
        })
      })
    }), /*#__PURE__*/_jsx(HR, {
      distance: "flush"
    }), /*#__PURE__*/_jsxs(Flex, {
      padding: "500",
      rowGap: "500",
      flexDirection: "column",
      children: [businessUnit && /*#__PURE__*/_jsx(CampaignsPlatformLabelPopoverBusinessUnit, {
        businessUnitId: parseInt(businessUnit, 10)
      }), /*#__PURE__*/_jsx(CampaignsPlatformLabelPopoverProperty, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.popover.owner"
        }),
        value: owner ? /*#__PURE__*/_jsx(CampaignsPlatformLabelPopoverOwner, {
          ownerId: parseInt(owner, 10)
        }) : '--'
      }), /*#__PURE__*/_jsx(CampaignsPlatformLabelPopoverProperty, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.popover.goal"
        }),
        value: getPropertyValue(campaignCrmObject, 'hs_goal', '--')
      }), /*#__PURE__*/_jsxs(TFlex, {
        direction: "row",
        justify: "between",
        children: [/*#__PURE__*/_jsx(CampaignsPlatformLabelPopoverProperty, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "campaignSelect.popover.startDate"
          }),
          value: startDate ? I18n.moment(parseInt(startDate, 10)).format('L') : '--'
        }), /*#__PURE__*/_jsx(CampaignsPlatformLabelPopoverProperty, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "campaignSelect.popover.endDate"
          }),
          value: endDate ? I18n.moment(parseInt(endDate, 10)).format('L') : '--'
        })]
      }), /*#__PURE__*/_jsx(CampaignsPlatformLabelPopoverProperty, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.popover.notes"
        }),
        value: getPropertyValue(campaignCrmObject, 'hs_notes', '--')
      })]
    })]
  });
}
export default /*#__PURE__*/memo(CampaignsPlatformLabelPopover);